import { ChevronRight } from 'lucide-react';
import { Card, Typography } from './ui';
import styles from './WaitingNoteRow.module.css';

/**
 * The note row each screen uses to point at the OTHER half of "waiting on you"
 * (`native-apps/shared/outreach-needs-you/contract.json` rules 5 and 6):
 *  - Tasks › Action needed: "{count} people are waiting for your answer ›" → Outreach › Inbox filtered to Needs you;
 *  - Outreach: "{count} tasks need your attention ›" → Tasks › Action needed.
 * One sentence and a trailing chevron, the whole row the hit target. The caller decides the copy, the number (the
 * same one its half of the island pill shows, so the two cannot disagree), where it goes and its BI. It renders
 * nothing at zero — a note about nothing is not drawn.
 */
export function WaitingNoteRow({ count, text, onOpen, testId }: { count: number; text: string; onOpen: () => void; testId: string }) {
  if (count <= 0) return null;
  return (
    <div className={styles.wrap}>
      <Card variant="outline" size="sm" interactive component="button" onClick={onOpen} className={styles.row} data-waiting-note={testId}>
        <Typography variant="p2" color="primary" className={styles.text} component="span">
          {text}
        </Typography>
        <ChevronRight size={16} aria-hidden className={`${styles.chevron} dir-flip`} />
      </Card>
    </div>
  );
}
